/**
 * Created by José Rafael Gutierrez on 31/07/2020.
 */
import nextGeneral from '@/store/modules/next/general';
import nextBars from '@/store/modules/next/bars';
import nextDistribution from '@/store/modules/next/distribution';
import nextForce from '@/store/modules/next/force';
import nextTable from '@/store/modules/next/table';
import nextSoccer from '@/store/modules/next/soccer';
import nextTrend from '@/store/modules/next/trend';
import nextLive from '@/store/modules/next/live';

export default {
  nextGeneral,
  nextBars,
  nextDistribution,
  nextForce,
  nextTable,
  nextSoccer,
  nextTrend,
  nextLive,
};
